module.exports = __webpack_public_path__ + "img/OVCA_Fibroblasts.bd3a667d.png";